module.exports = __webpack_public_path__ + "resources/img/ico_loading.fe936c136afeb6fa44fa3e9bd947e6fd.gif";